export const applications = {
  // Hero
  heroTitle: 'التطبيقات',
  heroSubtitle: 'أداء مثبت عبر مشاريع البنية التحتية الحرجة والبناء في جميع أنحاء العالم.',

  // Intro
  introTitle: 'حلول ألياف الصلب متعددة الاستخدامات',
  introDesc: 'ألياف الصلب DYNAMIX ذات النهاية المعقوفة مصممة لتلبية المتطلبات الصارمة للبناء الحديث. من الأرضيات الصناعية إلى بطانة الأنفاق، تقدم أليافنا أداءً وموثوقية متسقة عبر مجموعة واسعة من التطبيقات.',

  // Applications
  app1Title: 'الأرضيات الصناعية والتجارية',
  app1Desc: 'المستودعات عالية الحركة ومراكز التوزيع ومرافق التصنيع والمساحات التجارية تتطلب حلول أرضيات متينة. توفر ألياف الصلب DYNAMIX تحكماً متفوقاً في التشققات ومقاومة الصدمات وقدرة تحمل الأحمال، مما يقلل تكاليف الصيانة ويمدد عمر خدمة الأرضية.',
  app1Benefits: 'الفوائد',
  app1Benefit1: 'يلغي الحاجة لشبكة الأسلاك الملحومة',
  app1Benefit2: 'يقلل متطلبات سماكة البلاطة',
  app1Benefit3: 'يحسّن المقاومة للأحمال الثقيلة',
  app1Benefit4: 'يقلل صيانة المفاصل',

  app2Title: 'بطانة الأنفاق',
  app2Desc: 'البنية التحتية تحت الأرض تتطلب متانة استثنائية وسلامة. الخرسانة المرشوشة المعززة بألياف الصلب توفر أداءً متفوقاً في بناء الأنفاق، مما يوفر تحكماً ممتازاً في التشققات ومقاومة الصدمات وسلامة هيكلية طويلة الأمد في البيئات تحت الأرض الصعبة.',
  app2Benefits: 'الفوائد',
  app2Benefit1: 'التصاق محسّن للخرسانة المرشوشة',
  app2Benefit2: 'مقاومة متفوقة للتشققات',
  app2Benefit3: 'سلامة محسّنة أثناء البناء',
  app2Benefit4: 'ارتداد مخفض في تطبيق الخرسانة المرشوشة',

  app3Title: 'أرضيات الجسور والبنية التحتية',
  app3Desc: 'جسور الطرق السريعة والسكك الحديدية تواجه أحمال حركة مستمرة والتعرض البيئي. تحسّن ألياف الصلب DYNAMIX متانة الخرسانة وتتحكم في التشققات من الإجهاد الحراري والانكماش، وتحسّن المقاومة لدورات التجميد والذوبان والمواد الكيميائية لإزالة الجليد.',
  app3Benefits: 'الفوائد',
  app3Benefit1: 'عمر خدمة ممتد',
  app3Benefit2: 'متطلبات صيانة مخفضة',
  app3Benefit3: 'مقاومة تعب محسّنة',
  app3Benefit4: 'متانة أفضل في الظروف القاسية',

  app4Title: 'عناصر الخرسانة مسبقة الصب',
  app4Desc: 'المكونات المعمارية والهيكلية مسبقة الصب تستفيد من الخصائص المحسّنة لتعزيز ألياف الصلب. تحسّن أليافنا قوة المعالجة وتقلل التشققات أثناء إزالة القالب والنقل، وتسمح بعناصر أرق وأخف دون المساس بالأداء.',
  app4Benefits: 'الفوائد',
  app4Benefit1: 'دورات إنتاج أسرع',
  app4Benefit2: 'سماكة عنصر مخفضة',
  app4Benefit3: 'إنهاء سطح محسّن',
  app4Benefit4: 'تكاليف نقل أقل',

  app5Title: 'الهياكل الهيدروليكية',
  app5Desc: 'السدود ومرافق معالجة المياه والهياكل البحرية تتطلب خرسانة يمكنها تحمل التعرض المستمر للماء والقوى الهيدروليكية. يوفر تعزيز ألياف الصلب تحكماً ممتازاً في التشققات ومقاومة التآكل ومتانة في البيئات الرطبة.',
  app5Benefits: 'الفوائد',
  app5Benefit1: 'عزل مائي متفوق',
  app5Benefit2: 'مقاومة تآكل ممتازة',
  app5Benefit3: 'نفاذية مخفضة',
  app5Benefit4: 'متانة طويلة الأمد في الظروف الرطبة',

  app6Title: 'الطبقات والإصلاحات',
  app6Desc: 'تطبيقات إصلاح الخرسانة والطبقات تتطلب مواد ترتبط جيداً بالهياكل الموجودة وتقاوم التشقق. تحسّن ألياف الصلب DYNAMIX قوة الربط وتتحكم في تشققات الانكماش وتحسّن الأداء طويل الأمد لأعمال الإصلاح.',
  app6Benefits: 'الفوائد',
  app6Benefit1: 'ربط ممتاز بالركيزة',
  app6Benefit2: 'تشققات انكماش مخفضة',
  app6Benefit3: 'تطبيق أسرع',
  app6Benefit4: 'عمر إصلاح ممتد',

  // CTA
  ctaTitle: 'ابحث عن الحل المناسب لمشروعك',
  ctaSubtitle: 'فريقنا التقني جاهز لمساعدتك في اختيار مواصفات وجرعة ألياف الصلب المثلى لتطبيقك المحدد.',
  getTechnicalSupport: 'احصل على الدعم التقني',

  // More Applications
  moreAppsTitle: 'المزيد من التطبيقات',
  moreAppsSubtitle: 'حلول متعددة الاستخدامات لتحديات البناء المتنوعة.',

  precastTitle: 'عناصر مسبقة الصب',
  precastDesc: 'مثالية للألواح الخرسانية مسبقة الصب، والعوارض، والعناصر المعمارية التي تتطلب قوة ومتانة عالية.',

  pavementsTitle: 'الأرصفة والطرق',
  pavementsDesc: 'يعزز أداء الأرصفة الخرسانية، ويقلل من التشقق ويمدد عمر الخدمة تحت حركة المرور الثقيلة.',

  foundationsTitle: 'بلاطات الأساس',
  foundationsDesc: 'يوفر تحكماً فائقاً في التشقق وتوزيعاً للأحمال لأنظمة الأساسات السكنية والتجارية.',

  waterTanksTitle: 'خزانات المياه والمسابح',
  waterTanksDesc: 'ممتاز للهياكل المحتفظة بالمياه، حيث يوفر مقاومة للتشقق وتعزيزاً للعزل المائي.',

  blastResistantTitle: 'هياكل مقاومة للانفجار',
  blastResistantDesc: 'يحسن مقاومة الصدمات والانفجارات للبنية التحتية الحيوية للأمن والتطبيقات العسكرية.',

  seismicTitle: 'المناطق الزلزالية',
  seismicDesc: 'ليونة محسنة وامتصاص للطاقة للهياكل في المناطق المعرضة للزلازل.',
};

